import pickByLodash from 'lodash.pickby';

/**
 * This is a port of pickBy function from lodash.
 * Lodash is bloated and not necessary in many cases.
 * There is no native equivalent to this without writing
 * a method and testing it, so a port of it will maintain the same behavior
 * and have a smaller footprint.
 */
export const pickBy = pickByLodash;
